import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { api } from "../lib/api";

export default function SearchPage() {
    const [params, setParams] = useSearchParams();
    const q = params.get("q") || "";
    const [input, setInput] = useState(q);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!q) return;
        setLoading(true);
        api.get("/articles", { params: { q, limit: 50 } })
            .then((r) => setResults(r.data))
            .finally(() => setLoading(false));
    }, [q]);

    const onSubmit = (e) => {
        e.preventDefault();
        setParams({ q: input });
    };

    return (
        <div className="bg-black text-white min-h-screen">
            <SEO title={q ? `Search · ${q}` : "Search"} noindex />
            <Header />
            <main className="max-w-[1200px] mx-auto px-4 md:px-8 py-12">
                <h1 className="font-display uppercase text-5xl md:text-7xl leading-none">Search</h1>
                <form onSubmit={onSubmit} className="mt-6 flex gap-2 max-w-xl">
                    <input
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Search articles, artists, vibes…"
                        data-testid="search-input"
                        className="flex-1 bg-black border border-streetz-line px-4 py-3 focus:border-streetz-red outline-none"
                    />
                    <button data-testid="search-submit" className="bg-streetz-red text-white overline px-5 inline-flex items-center gap-2 hover:bg-white hover:text-black">
                        <Search className="w-4 h-4" /> SEARCH
                    </button>
                </form>

                {q && (
                    <p className="text-streetz-muted mt-6">
                        {loading ? "Searching…" : `${results.length} result${results.length === 1 ? "" : "s"} for “${q}”`}
                    </p>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8" data-testid="search-results">
                    {results.map((a) => (
                        <Link
                            key={a.id}
                            to={`/article/${a.slug}`}
                            data-testid={`search-result-${a.slug}`}
                            className="bg-streetz-paper border border-streetz-line hover:border-streetz-red"
                        >
                            {a.image_url && (
                                <img src={a.image_url} alt={a.title} className="aspect-video object-cover" />
                            )}
                            <div className="p-5">
                                <span className="overline text-streetz-red">{a.category}</span>
                                <h3 className="font-display uppercase text-xl mt-1">{a.title}</h3>
                                <p className="text-sm text-streetz-muted mt-2 line-clamp-2">{a.excerpt}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
